import { User } from 'lib/types/global';

interface OrgBranchIds {
  branchIds: string[];
  orgIds: string[];
}

// Collect all org and branch ids from the payload.
const formatRestaurantCompanies = (orgs: any[] = []) => {
  const initialValue: OrgBranchIds = {
    branchIds: [],
    orgIds: [],
  };

  return orgs.reduce<OrgBranchIds>((acc, org) => {
    acc.orgIds.push(org.drnId);
    org.restaurants.forEach(({ drnId }: { drnId: string }) =>
      acc.branchIds.push(drnId),
    );
    return acc;
  }, initialValue);
};

export default function formatUser({
  id,
  drnId,
  drn,
  role,
  name,
  email,
  isSso,
  links,
  features,
  userJoinedAt,
  restaurantCompanies: orgs,
}: any): User {
  return {
    id,
    drnId,
    drn,
    role,
    name,
    email,
    isSso,
    links,
    features,
    userJoinedAt,
    ...formatRestaurantCompanies(orgs),
  };
}
